export function formatMoney(number, options = {}) {
  if (options.zero && number === 0) {
    return options.zero;
  }
  return `$${number.toFixed(2)}`
}

export function cleanDataForDb(data) {
  return Object.keys(data).reduce((acc, key) => {
    acc[key] = data[key] !== undefined ? data[key] : null;
    return acc;
  }, {});
};

export function dollarsToCents(dollars) {
  return Math.round(dollars * 100)
}

export function toStripeAddress(address) {
  return {
    city: address.city,
    country: 'US',
    line1: address.street_address,
    line2: address.address_optional,
    postal_code: address.postalCode,
    state: address.state,
  }
}
